import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ExportSelectionModeEnum } from '@connect-services/client/components/modals/data-export-modal/data-export-modal.component';
import { DataExportService } from '@connect-services/client/services/data-export.service';
import {
    MapModalSelectionModeEnum,
    SelectionService,
} from '@connect-services/client/services/map/selection/selection.service';
import { SelectionStateService } from '@connect-services/client/services/map/selection/selection-state.service';
import { ZoneDelimiterService } from '@connect-services/client/services/zone-delimiter.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-entity-table-selection',
    templateUrl: './entity-table-selection.component.html',
})
export class EntityTableSelectionComponent {
    protected readonly isEntitySelected = computed<boolean>(
        () => !!Object.values(this.selectionStateService.selectedEntitiesByLayerId()).length,
    );

    // eslint-disable-next-line @typescript-eslint/member-ordering
    protected readonly ButtonType = ButtonType;
    protected readonly dataExportService = inject(DataExportService);
    protected readonly ExportSelectionModeEnum = ExportSelectionModeEnum;
    protected readonly selectionService = inject(SelectionService);

    private readonly selectionStateService = inject(SelectionStateService);
    private readonly zoneDelimiterService = inject(ZoneDelimiterService);

    protected toggleSelectionMode(): void {
        const nextActive = !this.selectionService.isSelectionActive();
        this.selectionService.isSelectionActive.set(nextActive);
        this.selectionService.setModalMode(MapModalSelectionModeEnum.SELECTION);

        if (nextActive) {
            return;
        }

        void this.selectionService.clearAllSelections(true);
        void this.zoneDelimiterService.resetFilters();
    }
}
